<div class="address-page d-flex flex-column">
  <header class="address-header d-flex align-items-center px-3 py-2">
    <button class="back-button me-2" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
    </button>
    <h1 class="page-title mb-0">{{ editMode ? 'Edit Address' : 'Add New Address' }}</h1>
  </header>

  <main class="flex-fill container d-flex justify-content-center py-4">
    <div class="card address-card shadow-sm w-100 w-md-75 w-lg-50">
      <div class="card-body px-lg-5 py-4">
        <h2 class="card-title text-center mb-4">
          {{ editMode ? 'Edit Address' : 'Add New Address' }}
        </h2>

        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>

          <!-- Location section -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="fs-5 text-secondary"><i class="fas fa-map-marker-alt me-2"></i>Location</div>
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="selectLocation()">
              Detect location <i class="fas fa-crosshairs ms-1"></i>
            </button>
          </div>

          <div *ngIf="f('latVal').touched && f('latVal').invalid" class="text-danger mb-2">
            Please detect your location
          </div>
          <div class="mb-3" *ngIf="registerForm.value.latVal">
            <small class="text-muted">
              Lat: {{ registerForm.value.latVal }}, Lng: {{ registerForm.value.lngVal }}
            </small>
          </div>

          <!-- Title -->
          <div class="mb-3">
            <label class="form-label">Title</label>
            <input formControlName="title" class="form-control" placeholder="Home / Office" />
          </div>

          <!-- Address & City row -->
          <div class="row g-3 mb-3">
            <div class="col-md-6">
              <label class="form-label required">Address</label>
              <input formControlName="address" class="form-control" />
              <div *ngIf="f('address').touched && f('address').errors?.required" class="invalid-feedback d-block">
                Address is required
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label required">City</label>
              <input formControlName="city" class="form-control" />
              <div *ngIf="f('city').touched && f('city').errors?.required" class="invalid-feedback d-block">
                City is required
              </div>
            </div>
          </div>

          <!-- State & Zip code row -->
          <div class="row g-3 mb-3">
            <div class="col-md-6">
              <label class="form-label required">State</label>
              <input formControlName="state" class="form-control" />
              <div *ngIf="f('state').touched && f('state').errors?.required" class="invalid-feedback d-block">
                State is required
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label required">Zipcode</label>
              <input formControlName="zipcode" class="form-control" maxlength="6" pattern="\d{6}" />
              <div *ngIf="f('zipcode').touched && f('zipcode').errors" class="invalid-feedback d-block">
                <span *ngIf="f('zipcode').errors?.required">Zipcode is required</span>
                <span *ngIf="f('zipcode').errors?.pattern">Zipcode must be 6 digits</span>
              </div>
            </div>
          </div>

          <!-- Landmark & Area -->
          <div class="mb-3">
            <label class="form-label">Landmark</label>
            <input formControlName="landmark" class="form-control" placeholder="e.g. Near Mall" />
          </div>
          <div class="mb-3">
            <label class="form-label">Area</label>
            <input formControlName="area" class="form-control" />
          </div>

          <!-- Primary checkbox -->
          <div class="form-check mb-4">
            <input formControlName="primaryAddress" type="checkbox" id="primaryAddress" class="form-check-input" />
            <label for="primaryAddress" class="form-check-label">Make this primary</label>
          </div>

          <!-- Submit button -->
          <button type="submit" class="btn btn-primary w-100 py-2" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ editMode ? 'Update Address' : 'Save Address' }}
          </button>

        </form>
      </div>
    </div>
  </main>

</div>
